import React, { Fragment, useState, useEffect } from 'react';
import { Col, Card, CardHeader, CardBody, Form, Row } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, Search, Filter, Coupon, CouponList } from '../../../Constant';
import { useSelector } from 'react-redux';
import { deleteArea, deleteAreaRole, deleteCoupon, deleteCouponRole, viewCoupon, viewCouponRole } from '../../../CommonUrl';
import { CouponColumns } from '../../../Data/MockTable/SettingsTableHeader';
import Transparentspinner from '../../Common/Loader/Transparentspinner';

const CouponContainer = () => {
    const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: '10px' };
    const authState = useSelector((state) => state.auth);
    const [areaList, setAreaList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (searchKeyword == '') {
            setLoading(true);
            areaData();
        }
    }, [searchKeyword]);


    const handleSearchInputChange = (event) => {
        setSearchKeyword(event.target.value);
    };

    const handleFilterSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        areaData();
    };

    const redirectToEditForm = (data) => {
        const editFormURL = `${process.env.PUBLIC_URL}/settings/coupon-edit?id=${data.id}`;
        navigate(editFormURL);
    };

    const deleteAreaList = (userId) => {
        SweetAlert.fire({
            title: 'Confirm deletion?',
            text: 'This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'cancel',
            reverseButtons: true
        }).then(async (result) => {
            setLoading(true);
            if (result.value) {
                const deleteRes = { coupon_id: userId }
                const areaDelete = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? deleteCoupon : deleteCouponRole, deleteRes);
                if (areaDelete.status === 200) {
                    SweetAlert.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    );
                    areaData();
                } else if (areaDelete.status >= 400 && areaDelete.status <= 405) {
                    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
                } else if (areaDelete.status >= 500 && areaDelete.status <= 505) {
                    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
                } else {
                    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
                }
            }
            setLoading(false);
        });
    };


    const areaData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewCoupon : viewCouponRole);
        if (data.status === true) {
            setLoading(true);
            if (Array.isArray(data.data)) {
                const filteredArea = data.data.filter((item) => {
                    const nameMatch = item.name && item.name.toLowerCase().includes(searchKeyword.toLowerCase());
                    const AreaMatch = item.area_code && item.area_code.toString().toLowerCase().includes(searchKeyword.toLowerCase());
                    return nameMatch || AreaMatch;
                });
                setAreaList(filteredArea.map((e, index) => {
                    return {
                        Si: index + 1,
                        Area: e.name,
                        Code: e.code,
                        Type: e.type,
                        Discount: e.discount,
                        Amount: e.min_amount,
                        Shipping: e.free_shipping,
                        Login: e.customer_login,
                        StartDate: e.start_date,
                        EndDate: e.end_date,
                        action:
                            <div>
                                {(authState.userRole === 1 || authState.permissions.includes('edit-coupon')) &&
                                    <span>
                                        <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToEditForm(e) }}>Edit </Btn>
                                    </span>
                                }
                                {(authState.userRole === 1 || authState.permissions.includes('remove-coupon')) &&
                                    <span>
                                        <Btn attrBtn={{ style: style2, className: 'me-2', color: 'danger btn-xs', type: 'button', onClick: () => { deleteAreaList(e.id) } }}>Delete</Btn>
                                    </span>
                                }
                            </div >
                    }
                }))
                setLoading(false);
            }
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };


    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={Coupon} parent="Settings" title={Coupon} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-5px 0 -20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{CouponList}</H3>
                    {(authState.userRole === 1 || authState.permissions.includes('store-coupon')) &&
                        <div>
                            <Link to={`${process.env.PUBLIC_URL}/settings/coupon-add`} className="btn btn-primary">{Add}</Link>
                        </div>
                    }
                </CardHeader>
                <CardBody>
                    <span className='custom-span'>
                        <Form className="needs-validation" noValidate onSubmit={handleFilterSubmit}>
                            <Row className="ps-3 mb-4 custom-search-filter align-items-center">
                                <Col xs="6" sm="4" md="2" lg="2">
                                    <input className="form-control" placeholder={Search} type="text" value={searchKeyword} onChange={handleSearchInputChange}
                                    />
                                </Col>
                                <Col xs="6" sm="6" md="4" lg="3">
                                    <Btn className="custom-filter-btn" attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            data={areaList}
                            columns={[
                                {
                                    name: <H4>Sl</H4>,
                                    selector: (row, index) => index + 1, // Assign SI dynamically based on current index
                                    width: '60px',
                                    sortable: false, // Disable sorting for SI
                                },
                                ...CouponColumns // All other columns remain the same
                            ]}
                            pagination
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            fixedHeader
                            style={{ border: '1px solid' }}
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default CouponContainer;